export { WorkingHoursService } from './working-hours.service';
